/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-11-09 16:53:55
 * @LastEditTime: 2022-03-10 18:12:20
 */
import { getFirstGroup, getSecondGroup} from '@/api/cloudMonitor/projectGroup'
import { getListByGroup } from '@/api/cloudMonitor/deviceList'
export const projectConfig = {
  data() {
    return {
      project: {},
      current: 1,
      size: 20,
      groupList: []
    }
  },
  methods: {
     // 获取一级列表
     getFirstList(node, resolve) {
      let params = {
        current: this.current,
        size: this.size
      }
      this.deviceList = []
      getFirstGroup(params).then(res => {
        if(res.data.code === 0) {
          let data = res.data.data
          this.projectList = data.records
          if(this.projectList.length > 0) {
            this.projectRadio = this.projectList[0]
          }
          this.project = this.projectList[0]
          resolve(data.records)
          this.total = data.total
          this.loading = false
          this.$emit('clickProject', this.project)
          this.$refs['groupTrees'].setCurrentKey(this.project.groupId)
        }else if(res.data.code === 3) {
          this.$message.warning('权限不足，无法操作！')
        }
      }).catch(() => {})
    },
    // 动态加载
    async loadNode(node, resolve) {
      console.log('这个是懒加载');
      let nodeData = []
      // 获取一级分组
      if(node.level === 0) {
        this.getFirstList(node, resolve)
      }else{
        getSecondGroup(node.data.groupId).then(res => {
          if(res.data.code === 0) {
            resolve(res.data.data)
          }
        })
      }
    },
    // 滑动滚动条
    scrollLoad() {
      this.current = this.current + 1
      let params = {
        current: this.current,
        size: this.size
      }
      getFirstGroup(params).then(res => {
        let data = res.data.data.records || []
          data.forEach(item => {
            this.$refs.groupTrees.append(item)
          })
      }).catch(() => {})
    },
  }
} 